import React from 'react'
import { Dropdown, Label } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { indexBy, prop } from 'ramda'
import VideoActions from 'Redux/VideoRedux'
import styles from './ToolBarStyles'

const options = [{
  key: 'approved', text: 'Approved', color: 'green', value: 'approved',
  label: { color: 'green', empty: true, circular: true }
}, {
  key: 'progress', text: 'In Progress', color: 'blue', value: 'progress',
  label: { color: 'blue', empty: true, circular: true }
}, {
  key: 'review', text: 'Need Review', color: 'yellow', value: 'review',
  label: { color: 'yellow', empty: true, circular: true }
}]

const optinsMap = indexBy(prop('key'), options)

export const VideoStatusDropDown = ({ video = {}, fetching, videosUpdateRequest, className }) => {
  const trigger = optinsMap[video.status]
      ? <Label color={optinsMap[video.status].color}>
          {optinsMap[video.status].text}
        </Label>
      : <Label
          color='grey'
          className='default text'
          role='alert'>Assign Label</Label>

  const onStatusChange = (_, { value }) => {
    if (video.status !== value) {
      videosUpdateRequest(video.id, { status: value })
    }
  }

  return (
    <div className={className}>
      <Dropdown
        className={styles.status}
        trigger={trigger}
        clearable
        loading={fetching}
        options={options}
        closeOnChange
        onChange={onStatusChange}
        value={video.status}
        placeholder='Assign Label'
        selectOnBlur={false} />
      </div>
  )

}


const mapStateToProps = (state) => ({
  fetching: state.videos.updateFetching
})

const mapDispatchToProps = (dispatch) => ({
  videosUpdateRequest: (id, payload) =>
    dispatch(VideoActions.videosUpdateRequest(id, payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(VideoStatusDropDown)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/ToolBar/VideoStatusDropDown.js